import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import { genericSelectValidatorRequired } from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.VEHICLE_OWNER_OWNER]: yup.object({
    [ComponentId.OWNER_TYPE]: genericSelectValidatorRequired,
  }),
};
